import React from "react";
import { Hero } from "./Hero";
import { AboutStudio } from "./AboutStudio";
import { Services } from "./Services";
import { Portfolio } from "./Portfolio";
import { Approach } from "./Approach";
import { Collections } from "./Collections";
import { Testimonials } from "./Testimonials";
import { InquiryForm } from "./InquiryForm";

function MainBody(props) {
  return (
    <div className='w-100'>
      <Hero />
      <AboutStudio />
      <Services />
      <Portfolio />
      <Approach />
      <Collections />
      <Testimonials />
      <InquiryForm />
    </div>
  );
}

export { MainBody };
